import type { DayOfWeek } from 'schema-dts';

/**
 * Business facts (name / address / phone / hours / geo / profiles). They feed the JSON-LD
 * business node and must match the footer, the contact page and the Google Business Profile
 * exactly. Every value here is copied from the site's visible copy (Footer.tsx and
 * pages/contact/page.tsx); nothing is guessed. config/seo.test.ts guards against placeholders.
 */
export const business = {
  /** Logo wordmark (header, footer) and the ChatBot's "iCCM Assistant". */
  brandName: 'iCCM',
  /** Footer tagline. */
  description:
    'Comprehensive chronic care management with integrative healthcare solutions for better patient outcomes.',
  // Address exactly as shown in the footer and on /contact.
  streetAddress: '2000 Town Center suite 1900',
  addressLocality: 'Southfield',
  addressRegion: 'MI',
  postalCode: '48075',
  addressCountry: 'US',
  phoneDisplay: '(844) 422-6633',
  phoneE164: '+18444226633',
  email: 'emma@integratedccm.com',
  /**
   * Unknown: the site shows no map pin, and the old index.html geo tags (Los Angeles,
   * "Medical District, CA") contradict the visible Southfield, MI address. Omitted from the
   * schema until the Google Business Profile pin is confirmed (R20).
   */
  geo: null as { latitude: number; longitude: number } | null,
  /** "Office Hours" on /contact: Mon-Fri 8:00 AM - 6:00 PM, Sat 9:00 AM - 2:00 PM. */
  openingHours: [
    { dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '08:00', closes: '18:00' },
    { dayOfWeek: ['Saturday'], opens: '09:00', closes: '14:00' },
  ] as { dayOfWeek: Extract<DayOfWeek, string>[]; opens: string; closes: string }[],
  /** Real, verified profile URLs only. The footer's social icons link to the networks' home pages. */
  sameAs: [] as string[],
} as const;
